import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import LandingPage from '../pages/Landing';
import LoansPage from '../pages/Loans';
import ApplyPage from '../pages/Apply';

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<LandingPage />} />
    <Route path="/landing" element={<LandingPage />} />
    <Route path="/loans" element={<LoansPage />} />
    <Route path="/apply" element={<ApplyPage />} />
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>
);

export default AppRoutes;
